// Learning Paths and Units Data
// This file contains data for personalized learning paths and unit structures

export const learningPaths = [
  {
    id: 'peter_learning_path',
    userId: 'peter',
    title: {
      traditional: 'Peter的學習路徑',
      simplified: 'Peter的学习路径',
      english: "Peter's Learning Path"
    },
    description: {
      traditional: '專為Peter設計的個人化英語學習路徑',
      simplified: '专为Peter设计的个性化英语学习路径',
      english: 'Personalized English learning path designed for Peter'
    },
    totalUnits: 8,
    totalLessons: 64,
    cefrLevel: 'A1',
    difficulty: 'beginner',
    estimatedDuration: '12 weeks',
    progress: {
      completedUnits: 0,
      completedLessons: 1,
      totalProgress: 0.015 // 1/64 lessons completed
    },
    rating: 5,
    points: 140,
    isActive: true,
    createdAt: '2024-01-15',
    lastAccessed: '2024-01-20'
  }
];

export const units = [
  {
    id: 'unit_1',
    learningPathId: 'peter_learning_path',
    unitNumber: 1,
    title: {
      traditional: '打包行李',
      simplified: '打包行李',
      english: 'Packing your bags'
    },
    description: {
      traditional: '談論汽車零件時使用過去進行時',
      simplified: '谈论汽车零件时使用过去进行时',
      english: 'Talk about car parts while using the past continuous tense'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['luggage', 'passport', 'ticket', 'airport', 'travel'],
    grammarTopics: ['past_continuous', 'present_perfect'],
    isUnlocked: true,
    isCompleted: false
  },
  {
    id: 'unit_2',
    learningPathId: 'peter_learning_path',
    unitNumber: 2,
    title: {
      traditional: '機場安檢',
      simplified: '机场安检',
      english: 'Airport Security'
    },
    description: {
      traditional: '學習機場安檢相關詞彙和表達',
      simplified: '学习机场安检相关词汇和表达',
      english: 'Learn airport security vocabulary and expressions'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['security', 'check', 'passport', 'boarding_pass', 'metal_detector'],
    grammarTopics: ['imperatives', 'polite_requests'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_3',
    learningPathId: 'peter_learning_path',
    unitNumber: 3,
    title: {
      traditional: '飛機上',
      simplified: '飞机上',
      english: 'On the Plane'
    },
    description: {
      traditional: '飛機上的對話和服務用語',
      simplified: '飞机上的对话和服务用语',
      english: 'Conversations and service language on the plane'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['flight_attendant', 'seat', 'meal', 'beverage', 'turbulence'],
    grammarTopics: ['requests', 'offers'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_4',
    learningPathId: 'peter_learning_path',
    unitNumber: 4,
    title: {
      traditional: '抵達目的地',
      simplified: '抵达目的地',
      english: 'Arriving at Destination'
    },
    description: {
      traditional: '抵達機場後的入境和海關程序',
      simplified: '抵达机场后的入境和海关程序',
      english: 'Immigration and customs procedures upon arrival'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['immigration', 'customs', 'declaration', 'visa', 'stamp'],
    grammarTopics: ['present_simple', 'questions'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_5',
    learningPathId: 'peter_learning_path',
    unitNumber: 5,
    title: {
      traditional: '酒店入住',
      simplified: '酒店入住',
      english: 'Hotel Check-in'
    },
    description: {
      traditional: '酒店預訂和入住相關對話',
      simplified: '酒店预订和入住相关对话',
      english: 'Hotel booking and check-in conversations'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['reservation', 'check_in', 'room', 'key', 'amenities'],
    grammarTopics: ['future_simple', 'making_reservations'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_6',
    learningPathId: 'peter_learning_path',
    unitNumber: 6,
    title: {
      traditional: '餐廳用餐',
      simplified: '餐厅用餐',
      english: 'Dining at Restaurant'
    },
    description: {
      traditional: '餐廳點餐和用餐禮儀',
      simplified: '餐厅点餐和用餐礼仪',
      english: 'Restaurant ordering and dining etiquette'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['menu', 'appetizer', 'main_course', 'dessert', 'bill'],
    grammarTopics: ['would_like', 'ordering_food'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_7',
    learningPathId: 'peter_learning_path',
    unitNumber: 7,
    title: {
      traditional: '購物',
      simplified: '购物',
      english: 'Shopping'
    },
    description: {
      traditional: '購物對話和討價還價',
      simplified: '购物对话和讨价还价',
      english: 'Shopping conversations and bargaining'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['price', 'discount', 'size', 'color', 'payment'],
    grammarTopics: ['comparatives', 'bargaining'],
    isUnlocked: false,
    isCompleted: false
  },
  {
    id: 'unit_8',
    learningPathId: 'peter_learning_path',
    unitNumber: 8,
    title: {
      traditional: '緊急情況',
      simplified: '紧急情况',
      english: 'Emergency Situations'
    },
    description: {
      traditional: '處理緊急情況和尋求幫助',
      simplified: '处理紧急情况和寻求帮助',
      english: 'Handling emergency situations and seeking help'
    },
    totalLessons: 8,
    completedLessons: 0,
    progress: 0,
    difficulty: 'beginner',
    estimatedDuration: '1 week',
    vocabulary: ['emergency', 'help', 'hospital', 'police', 'ambulance'],
    grammarTopics: ['emergency_phrases', 'asking_for_help'],
    isUnlocked: false,
    isCompleted: false
  }
];

export const lessons = [
  // Unit 1 Lessons
  {
    id: 'lesson_1_1',
    unitId: 'unit_1',
    lessonNumber: 1,
    title: {
      traditional: '建造引擎',
      simplified: '建造引擎',
      english: 'Building the Engine'
    },
    type: 'grammar',
    typeIcon: 'a',
    description: {
      traditional: '學習過去進行時的基本用法',
      simplified: '学习过去进行时的基本用法',
      english: 'Learn basic usage of past continuous tense'
    },
    duration: 15,
    difficulty: 'beginner',
    isCompleted: true,
    isUnlocked: true,
    content: {
      vocabulary: ['engine', 'build', 'work', 'repair'],
      grammar: 'past_continuous',
      exercises: ['fill_blank', 'multiple_choice']
    }
  },
  {
    id: 'lesson_1_2',
    unitId: 'unit_1',
    lessonNumber: 2,
    title: {
      traditional: '工作坊的聲音',
      simplified: '工作坊的声音',
      english: 'Sounds of the Workshop'
    },
    type: 'pronunciation',
    typeIcon: '🎤',
    description: {
      traditional: '練習工作相關詞彙的發音',
      simplified: '练习工作相关词汇的发音',
      english: 'Practice pronunciation of work-related vocabulary'
    },
    duration: 12,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      vocabulary: ['workshop', 'sound', 'noise', 'machine'],
      pronunciation: ['workshop', 'sound', 'noise'],
      exercises: ['pronunciation_practice', 'listening']
    }
  },
  {
    id: 'lesson_1_3',
    unitId: 'unit_1',
    lessonNumber: 3,
    title: {
      traditional: '什麼沒有工作',
      simplified: '什么没有工作',
      english: 'What Wasn\'t Working'
    },
    type: 'grammar',
    typeIcon: 'a',
    description: {
      traditional: '過去進行時的否定形式',
      simplified: '过去进行时的否定形式',
      english: 'Negative form of past continuous tense'
    },
    duration: 18,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: true,
    content: {
      vocabulary: ['work', 'function', 'operate', 'break'],
      grammar: 'past_continuous_negative',
      exercises: ['sentence_formation', 'translation']
    }
  },
  {
    id: 'lesson_1_4',
    unitId: 'unit_1',
    lessonNumber: 4,
    title: {
      traditional: '引擎聲音',
      simplified: '引擎声音',
      english: 'Vroom Vroom Sounds'
    },
    type: 'grammar',
    typeIcon: 'a',
    description: {
      traditional: '描述聲音和動作的詞彙',
      simplified: '描述声音和动作的词汇',
      english: 'Vocabulary for describing sounds and actions'
    },
    duration: 14,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: false,
    content: {
      vocabulary: ['vroom', 'sound', 'engine', 'noise'],
      grammar: 'describing_sounds',
      exercises: ['vocabulary_matching', 'listening']
    }
  },
  {
    id: 'lesson_1_5',
    unitId: 'unit_1',
    lessonNumber: 5,
    title: {
      traditional: '進行中',
      simplified: '进行中',
      english: 'In Progress'
    },
    type: 'reading',
    typeIcon: '📖',
    description: {
      traditional: '閱讀關於工作進度的文章',
      simplified: '阅读关于工作进度的文章',
      english: 'Reading about work progress'
    },
    duration: 20,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: false,
    content: {
      vocabulary: ['progress', 'ongoing', 'continue', 'complete'],
      reading: 'work_progress_article',
      exercises: ['reading_comprehension', 'vocabulary']
    }
  },
  {
    id: 'lesson_1_6',
    unitId: 'unit_1',
    lessonNumber: 6,
    title: {
      traditional: '工具名稱',
      simplified: '工具名称',
      english: 'Tool Names'
    },
    type: 'vocabulary',
    typeIcon: '📚',
    description: {
      traditional: '學習工作坊常用工具的名稱',
      simplified: '学习工作坊常用工具的名称',
      english: 'Learn names of common workshop tools'
    },
    duration: 16,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: false,
    content: {
      vocabulary: ['hammer', 'screwdriver', 'wrench', 'pliers'],
      exercises: ['picture_matching', 'spelling']
    }
  },
  {
    id: 'lesson_1_7',
    unitId: 'unit_1',
    lessonNumber: 7,
    title: {
      traditional: '安全規則',
      simplified: '安全规则',
      english: 'Safety Rules'
    },
    type: 'speaking',
    typeIcon: '🗣️',
    description: {
      traditional: '練習談論工作安全規則',
      simplified: '练习谈论工作安全规则',
      english: 'Practice talking about workplace safety rules'
    },
    duration: 22,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: false,
    content: {
      vocabulary: ['safety', 'rule', 'protect', 'danger'],
      speaking: 'safety_conversation',
      exercises: ['role_play', 'speaking_practice']
    }
  },
  {
    id: 'lesson_1_8',
    unitId: 'unit_1',
    lessonNumber: 8,
    title: {
      traditional: '單元測驗',
      simplified: '单元测验',
      english: 'Unit Test'
    },
    type: 'test',
    typeIcon: '📝',
    description: {
      traditional: '測試第一單元的所有內容',
      simplified: '测试第一单元的所有内容',
      english: 'Test all content from Unit 1'
    },
    duration: 25,
    difficulty: 'beginner',
    isCompleted: false,
    isUnlocked: false,
    content: {
      test: 'unit_1_comprehensive',
      exercises: ['multiple_choice', 'fill_blank', 'speaking']
    }
  }
];

// Get learning path by user ID
export const getLearningPathByUserId = (userId) => {
  return learningPaths.find(path => path.userId === userId);
};

// Get units by learning path ID
export const getUnitsByLearningPathId = (learningPathId) => {
  return units.filter(unit => unit.learningPathId === learningPathId);
};

// Get lessons by unit ID
export const getLessonsByUnitId = (unitId) => {
  return lessons.filter(lesson => lesson.unitId === unitId);
};

// Get lesson by ID
export const getLessonById = (lessonId) => {
  return lessons.find(lesson => lesson.id === lessonId);
};

// Get unit by ID
export const getUnitById = (unitId) => {
  return units.find(unit => unit.id === unitId);
};

// Calculate unit progress
export const calculateUnitProgress = (unitId) => {
  const unitLessons = getLessonsByUnitId(unitId);
  const completedLessons = unitLessons.filter(lesson => lesson.isCompleted).length;
  return {
    completed: completedLessons,
    total: unitLessons.length,
    percentage: (completedLessons / unitLessons.length) * 100
  };
};

// Update lesson completion status
export const updateLessonCompletion = (lessonId, isCompleted) => {
  const lesson = lessons.find(l => l.id === lessonId);
  if (lesson) {
    lesson.isCompleted = isCompleted;
  }
};

// Check if unit is unlocked
export const isUnitUnlocked = (unitId) => {
  const unit = getUnitById(unitId);
  if (!unit) return false;
  
  if (unit.unitNumber === 1) return true;
  
  const previousUnit = units.find(u => 
    u.learningPathId === unit.learningPathId && 
    u.unitNumber === unit.unitNumber - 1
  );
  
  if (!previousUnit) return false;
  
  const previousUnitProgress = calculateUnitProgress(previousUnit.id);
  return previousUnitProgress.percentage >= 80; // 80% completion required
};
